// build configuration from Environment variables
import { mergeUrlApi } from "./utils/string";

class AppConfig {
  API_ENDPOINT: string;
  BFF_ENDPOINT: string;

  constructor() {
    // Normally empty, so both paths stay relative and resolve against whatever origin
    // served the app - which is also the origin the session cookie was set on. The
    // ingress routes /odata and /bff to the API under the pimjobs host, and the dev
    // server proxies them locally.
    const apiOrigin: string = window.env?.API_ENDPOINT ?? "";

    this.API_ENDPOINT = mergeUrlApi(apiOrigin, "odata");
    this.BFF_ENDPOINT = mergeUrlApi(apiOrigin, "bff");
  }
}

const appConfig = new AppConfig();
export default appConfig;
